import { Link } from 'react-router-dom';
import type { Service } from '../lib/types';
import { ArrowRight } from 'lucide-react';

export function ServiceCard({ service }: { service: Service }) {
  const routeMap: Record<string, string> = {
    'desenvolvimento-web': '/web', 'dns-dominios': '/dns-dominios', 'servidores-cloud': '/servidores',
    'redes-provedores': '/redes', seguranca: '/seguranca', 'hospedagem-manutencao': '/servicos',
  };
  return <article className="service-card"><div className="service-icon" aria-hidden="true">{service.icon}</div><h2>{service.name}</h2><p>{service.shortDescription}</p><Link to={routeMap[service.slug] ?? '/servicos'}>Saiba mais <ArrowRight size={14} aria-hidden="true" /></Link></article>;
}
